<script>
import su1TotalCompletedSurvey from "../pages/results/components/SU1TotalCompletedSurvey.vue";
import su2TotalCompletedSurvey from "../pages/results/components/SU2TotalCompletedSurvey.vue";
import TotalEXIN from "../pages/results/components/total-ex-in.vue";
import KPIProgress from "./results/components/KPIProgress.vue";
import SustTargetsCompletion from "./results/components/SustTargetsCompletion.vue";
import TotalEmissionReductions from "./results/components/TotalEmissionReductions.vue";
import { mapActions, mapState } from 'vuex';
import { Carousel3d, Slide } from 'vue-carousel-3d';
import LoadingSpinner from "../components/LoadingSpinner.vue";
import Card from "../components/Card.vue";

export default {
	components: {
		su1TotalCompletedSurvey,
		su2TotalCompletedSurvey,
		TotalEXIN,
		KPIProgress,
		SustTargetsCompletion,
		TotalEmissionReductions,
		Carousel3d,
		Slide,
		LoadingSpinner,
		Card
	},

	data() {
		return {
			loading: true,
			showDescription: false,
			hoveredIndex: null,
			carouselOptions: {
				loop: false,
				controlsVisible: true,
				startIndex: 0
			},
		};
	},

	computed: {
		...mapState('app', [
			'companyLicence',
		]),
		
		...mapState('settings', [
			'process_track_id',
			'steps'
		]),

		isAuditor() {
			return this.companyLicence.plan_id === -1;
		},
	},

	mounted() {
		if (this.isAuditor) {
			this.$router.push("/audited-companies");
		} else {
			this.findStartingStep();
		}
	},

	methods: {
		...mapActions('settings', [
			'updateProcessTrack',
		]),

		...mapActions('company', [
			'checkReportsPublished',
		]),

		updateProcess(step) {
			const params = {
				[`is_step_${step.step_number}_completed`]: !step.completed,
				updated_by: this.$user.user_id,
				reporting_process_track_id: this.process_track_id,
			};

			this.updateProcessTrack(params)
				.then(res => {
					this.$notify('success', res.data.messageName);
					step.completed = !step.completed;
				})
				.catch(({ response }) => {
					this.$notify('error', response.data.messageName);
				})
		},

		goToUserPage() {
			this.$router.push("/stakeholders");
		},

		goToCompanyPage() {
			this.$router.push("/company");
		},

		goToStepPage(step, isCurrent) {
			if (isCurrent) {
				this.$router.push(step.route_link)
			}
		},

		handleMouseOver(isCurrent, index) {
			if (isCurrent) {
				this.showDescription = true;
				this.hoveredIndex = index;
			}
			else {
				this.showDescription = false;
			}
		},

		findStartingStep() {
			if (!this.steps || this.steps.length === 0) {
				setTimeout(() => {
					this.findStartingStep();
				}, 150);
				return;
			}

			let mySteps = this.steps;
			let startIndex = this.steps.find(item => item.completed == false && item.skippable == false);

			if (!startIndex) {
				startIndex = this.steps[0];
			}

			for (let i = 0; i < mySteps.length; i++) {
				const step = mySteps[i];
				
				if (i == (startIndex.step_number - 1)) {
					step.upNext = true;
					this.carouselOptions.startIndex = i;
				}
				else {
					step.upNext = false;
				}
			}

			this.loading = false;
		},

		backToStart() {
			const element = document.querySelector('[data-index="0"]');
			if (!element.classList.contains('current')) {
				element.click();
			}
		},

	},
};
</script>

<template>
	<div>
		<div v-if="loading" class="flex-all-centered-row" style="font-size: 3em; padding-top: 2em;">
			<loading-spinner />
		</div>

		<Card style="padding: 1em;" v-else-if="!isAuditor">
			<carousel-3d style="overflow: visible;" :loop="carouselOptions.loop"
				:controlsVisible="carouselOptions.controlsVisible" :startIndex="carouselOptions.startIndex">
				<slide v-for="(step, i) in steps" :index="i" :key="i" class="slide-of-step">
					<template slot-scope="{ index, isCurrent, leftIndex, rightIndex }">
						<div :data-index="index"
							:class="{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0) }"
							@mouseover="handleMouseOver(isCurrent, index)" @click="goToStepPage(step, isCurrent)">
							<div v-if="showDescription == true && hoveredIndex == index" class="back-of-card">
								<div class="step-slide-title" :class="{ 'card-smaller-font': step.long_text }">
									{{ step.title }}
								</div>
								<div class="step-slide-description">
									{{ step.tooltip }}
								</div>
								<div class="step-number">
									{{ step.step_number }}
								</div>
								<div v-if="step.completed == false" class="process-track back-process-track-incomplete"
									:class="{ 'active-process': step.upNext, 'process-track-inactive': step.is_disabled }"
									@click.stop="updateProcess(step)">
									<span v-if="step.skippable">{{ $t('dashboard.steps.cards.skippable') }}</span>
									<span v-else-if="!step.upNext">{{ $t('dashboard.steps.cards.incomplete') }}</span>
									<span v-else>{{ $t('dashboard.steps.cards.active') }}</span>
									<i class="fa-regular fa-circle" style="color: #68a1b9"></i>
								</div>
								<div v-if="step.completed == true" class="process-track back-process-track-complete"
									:class="{ 'process-track-inactive': step.is_disabled }"
									@click.stop="updateProcess(step)">
									<span>{{ $t('dashboard.steps.cards.complete') }}</span>
									<i class="fa-regular fa-circle-check"></i>
								</div>
							</div>
							<div v-else>
								<img :src="step.imageSrc">
								<div class="step-slide-title--front">
									{{ step.title }}
								</div>
								<div class="step-number step-number--front">
									{{ step.step_number }}
								</div>
								<div v-if="step.completed == false" class="process-track front-process-track-incomplete"
									:class="{ 'active-process': step.upNext, 'process-track-inactive': step.is_disabled }">
									<span v-if="step.skippable">{{ $t('dashboard.steps.cards.skippable') }}</span>
									<span v-else-if="!step.upNext">{{ $t('dashboard.steps.cards.incomplete') }}</span>
									<span v-else>{{ $t('dashboard.steps.cards.active') }}</span>
									<i class="fa-regular fa-circle" style="color: #68a1b9"></i>
								</div>
								<div v-if="step.completed == true" class="process-track front-process-track-complete"
									:class="{ 'process-track-inactive': step.is_disabled }">
									<span>{{ $t('dashboard.steps.cards.complete') }}</span>
									<i class="fa-regular fa-circle-check"></i>
								</div>
							</div>
						</div>
					</template>
				</slide>
			</carousel-3d>
			<div class="back-to-start-container" @click="backToStart">
				<i class="fa-solid fa-rotate-left back-to-start-button"></i>
			</div>
		</card>

		<div v-else>
			Auditor company
		</div>
	</div>
</template>

<style lang="scss" scoped>
.slide-of-step {
	width: 58% !important;
	height: 100% !important;
	left: 20.9% !important;

	background-color: #023047;

	border-radius: 1em !important;
	outline: .2em solid #023047 !important;

	cursor: pointer;
}

.step-slide-title--front {
	z-index: 99;
	position: absolute;
	top: .33em;
	left: .2em;
	font-size: 1.5em;
	color: #023047;
	font-weight: bold;
	text-align: center;
}

.back-of-card {
	background: #023047;
}

.step-slide-title {
	padding: .33em;
	z-index: 99;
	font-size: 1.1em;
	color: white;
	font-weight: bold;
	text-align: center;
}

.card-smaller-font {
	font-size: 1em !important;
}

.step-slide-description {
	padding: .33em;
	z-index: 99;
	font-size: 1em;
	color: white;
	text-align: center;
}

.step-number {
	display: flex;
	justify-content: center;
	align-content: center;
	align-items: center;

	max-width: 1.5em;
	max-height: 1.5em;
	border-radius: .5em;
	padding: .33em;
	padding-right: .37em;

	background-color: white;
	color: #023047;
	font-weight: bold;
	text-align: center;

	position: absolute;
	bottom: .5em;
	left: .5em;
}

.step-number--front {
	border: thin solid #023047;
}

.process-track {
	position: absolute;
	text-align: left;
	padding-left: .25em;
	border-radius: .25em;

	&:hover {
		background-color: whitesmoke;
	}
}

.active-process {
	color: #e19600 !important;
	outline: .2em solid #e19600 !important;
}

.front-process-track-incomplete {
	display: flex;
	flex-direction: row;
	bottom: 2.5%;
	right: 5%;
	color: #023047;
	font-weight: 600;
	font-size: 12px;
	background-color: white;
	width: 100px;
	outline: .2em solid #68a1b9;
}

.front-process-track-complete {
	display: flex;
	flex-direction: row;
	bottom: 2.5%;
	right: 5%;
	color: #aad88b;
	font-weight: 600;
	font-size: 12px;
	background-color: white;
	width: 100px;
	outline: .2em solid #84b370;
}

.back-process-track-incomplete {
	display: flex;
	flex-direction: row;
	bottom: 2.5%;
	right: 5%;
	color: #023047;
	font-weight: 600;
	font-size: 12px;
	background-color: white;
	width: 100px;
	outline: .2em solid #68a1b9;
}

.back-process-track-complete {
	display: flex;
	flex-direction: row;
	bottom: 2.5%;
	right: 5%;
	color: #aad88b;
	font-weight: 600;
	font-size: 12px;
	background-color: white;
	width: 100px;
	outline: .2em solid #84b370;
}

.process-track-inactive {
	pointer-events: none;
	filter: grayscale(100%);
}

.fa-regular {
	position: absolute;
	right: .25em;
	top: .25em
}

.back-to-start-container {
	display: flex;
	justify-content: center;
	align-content: center;
	align-items: center;
	text-align: center;
	align-self: center;

	border-radius: 1em;
	padding: .33em;
}

.back-to-start-container:hover {
	background: #5757572a;
	filter: brightness(25%);
	cursor: pointer;
}



.custom-round {
	border-radius: 20px;
	background: #f5f5f5;
}
</style>
